import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';


@Component({
  selector: 'app-progress-section',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './progress-section.component.html',
  styleUrls: ['./progress-section.component.scss']
})
export class ProgressSectionComponent {
  @Input() public currentStep = 0;

  public get progressPercentage(): number {
    return (this.currentStep - 1) * 25;
  }
}
